module.exports = __webpack_public_path__ + "static/media/Mission-ctrl.8b6e1250.png";